/*
 * Copyright (c) 2025 curryfirm.com
 */

// app/store.js
import { configureStore } from '@reduxjs/toolkit';
import dumpsReducer from '../features/dumps/dumpsSlice.js';
import dumpstersReducer from '../features/dumpsters/dumpstersSlice.js';
import workflowReducer from '../features/workflow/workflowSlice.js';
import locationsReducer from '../features/locations/locationsSlice.js';
import routingReducer from '../features/routing/routingSlice.js';
import routingInputsChangeListener from "../features/routing/routingInputsChangeListener.js";

export const store = configureStore({
    reducer: {
        dumps: dumpsReducer,
        dumpsters: dumpstersReducer,
        locations: locationsReducer,
        workflow: workflowReducer,
        routing: routingReducer,
    },
    middleware: (getDefaultMiddleware) =>
        // Add listener **before** default middleware to avoid serializability warnings.
    getDefaultMiddleware().prepend(routingInputsChangeListener.middleware),
});

